/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ReportService } from './services/report.service';
import { HealthService } from './services/health.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ReportService,
    HealthService,
    ApiConfiguration
  ],
})
export class LegacyReportsModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<LegacyReportsModule> {
    return {
      ngModule: LegacyReportsModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: LegacyReportsModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('LegacyReportsModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
